export const formatData = (bytes: number) => {
  const gb = bytes / 1073741824 // 1GB = 1024^3 bytes
  const mb = bytes / 1048576    // 1MB = 1024^2 bytes

  if (gb >= 1) {
    return `${gb.toFixed(gb % 1 === 0 ? 0 : 1)}GB`
  } else if (mb >= 1) {
    return `${Math.round(mb)}MB`
  } else {
    return `${Math.round(bytes / 1024)}KB`
  }
}

export const formatPrice = (price: number) => {
  // Price is stored as value * 10,000 (10000 = $1.00)
  return (price / 10000).toFixed(2)
}

export const getFlag = (slug: string): string => {
  if (slug.startsWith('EU')) return 'https://buyesimdata.com/wp-content/uploads/2026/01/eu_flag.svg'
  if (slug.startsWith('CIS')) return 'https://buyesimdata.com/wp-content/uploads/2026/01/cis_flag.svg'
  if (slug.startsWith('AS')) return 'https://buyesimdata.com/wp-content/uploads/2026/01/asa_flag.svg'
  if (slug.startsWith('AF')) return 'https://buyesimdata.com/wp-content/uploads/2026/01/afr_flag.svg'
  if (slug.startsWith('SA')) return 'https://buyesimdata.com/wp-content/uploads/2026/01/lat_flag.svg'
  if (slug.startsWith('NA')) return 'https://buyesimdata.com/wp-content/uploads/2026/01/nam_flag.svg'
  if (slug.startsWith('ME')) return 'https://buyesimdata.com/wp-content/uploads/2026/01/mena_flag.svg'
  if (slug.startsWith('CB')) return 'https://buyesimdata.com/wp-content/uploads/2026/01/lat_flag.svg'
  if (slug.startsWith('GL')) return 'https://buyesimdata.com/wp-content/uploads/2026/01/lat_flag.svg'
  
  return `https://flagcdn.com/${slug.toLowerCase()}.svg`
}
